import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * FadeAnimation class
 */
export default class FadeAnimation {
    constructor() {
        /**
         *
         * @type {{smallElements: string, largeElements: string, mediumElements: string}}
         */
        this.defaults = {
            //elements
            largeElements: ".js-fade-big",
            mediumElements: ".js-fade-medium",
            smallElements: ".js-fade-small",
        };
    }

    //region methods
    /**
     * FadeAnimation class init method and init flag
     */
    init() {
        console.log("FadeAnimation init()");

        const large = document.querySelectorAll(this.defaults.largeElements);
        const medium = document.querySelectorAll(this.defaults.mediumElements);
        const small = document.querySelectorAll(this.defaults.smallElements);

        if (large.length > 0) {
            this.animateLarge(large);
        }

        if (medium.length > 0) {
            this.animateMedium(medium);
        }

        if (small.length > 0) {
            this.animateSmall(small);
        }
    }

    /**
     *
     * @param items
     */
    animateLarge(items) {
        for (let i = 0; i < items.length; i++) {
            if (!items[i].classList.contains("is-initialised")) {
                gsap.set(items[i], {
                    y: "15%",
                    skewY: "1.8deg",
                    autoAlpha: 0,
                });

                items[i].classList.add("is-initialised");

                const delay = this.delayByItemsInRow(items, items[i]);
                gsap.to(items[i], {
                    scrollTrigger: {
                        trigger: items[i],
                        start: "top 85%",
                        toggleActions: "play none play none",
                    },
                    y: "0%",
                    skewY: "0deg",
                    autoAlpha: 1,
                    ease: "power3.inOut",
                    duration: 0.75,
                    delay: delay,
                });
            }
        }
    }

    /**
     *
     * @param items
     */
    animateMedium(items) {
        for (let i = 0; i < items.length; i++) {
            if (!items[i].classList.contains("is-initialised")) {
                gsap.set(items[i], {
                    y: "20%",
                    skewY: "2.5deg",
                    autoAlpha: 0,
                });

                items[i].classList.add("is-initialised");

                const delay = this.delayByItemsInRow(items, items[i]);

                gsap.to(items[i], {
                    scrollTrigger: {
                        trigger: items[i],
                        start: "top 85%",
                        toggleActions: "play none play none",
                    },
                    y: "0%",
                    skewY: "0deg",
                    autoAlpha: 1,
                    ease: "power3.inOut",
                    duration: 0.6,
                    delay: delay,
                });
            }
        }
    }

    /**
     *
     * @param items
     */
    animateSmall(items) {
        for (let i = 0; i < items.length; i++) {
            if (!items[i].classList.contains("is-initialised")) {
                gsap.set(items[i], {
                    y: "20%",
                    skewY: "4deg",
                    autoAlpha: 0,
                });

                items[i].classList.add("is-initialised");

                const delay = this.delayByItemsInRow(items, items[i]);
                gsap.to(items[i], {
                    scrollTrigger: {
                        trigger: items[i],
                        start: "top 85%",
                        toggleActions: "play none play none",
                    },
                    y: "0%",
                    skewY: "0deg",
                    autoAlpha: 1,
                    ease: "power3.inOut",
                    duration: 0.5,
                    delay: delay,
                });
            }
        }
    }

    /**
     *
     * @param items
     * @param current
     * @returns {number}
     */
    delayByItemsInRow(items, current) {
        const indexes = [];
        for (let i = 0; i < items.length; i++) {
            if (items[i].getBoundingClientRect().top === current.getBoundingClientRect().top) {
                indexes.push(i);
            }
        }

        const sum = indexes[indexes.length - 1] - indexes[0];

        if (sum === 0) {
            return 0;
        } else {
            for (let i = 0; i <= sum; i++) {
                if (items[indexes[i]] === current) {
                    return i * 0.15;
                }
            }
        }
    }

    //endregion
}
